import { render, staticRenderFns } from "./AddRevenuePage.vue?vue&type=template&id=7edd6af0"
import script from "./AddRevenuePage.vue?vue&type=script&lang=js"
export * from "./AddRevenuePage.vue?vue&type=script&lang=js"
import style0 from "./AddRevenuePage.vue?vue&type=style&index=0&id=7edd6af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports